import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AgrPageToolbarModule } from '@next/core-lib/components';
import { AgrSharedModule } from '@next/core-lib/shared';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { MeasurementsOverviewComponent } from './components/measurements-overview/measurements-overview.component';
import * as MeasurementsActions from './store/measurements.actions';
import { SiteState } from '../shared/models/models';

@Component({
  selector: 'app-measurements',
  templateUrl: './measurements.component.html',
  styleUrls: ['./measurements.component.scss'],
  imports: [AsyncPipe, AgrPageToolbarModule, AgrSharedModule, MeasurementsOverviewComponent],
})
export class MeasurementsComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);

  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);

  ngOnInit() {
    this.store.dispatch(SiteActions.updatePageTitle({ pageTitle: 'app.measurements-module' }));
    this.store.dispatch(MeasurementsActions.loadMeasurementOverviewRequest());
  }

  ngOnDestroy() {
    this.store.dispatch(MeasurementsActions.clearMeasurementOverview());
  }

  openNewMeasurementWizard(): void {
    this.store.dispatch(MeasurementsActions.initializeMeasurementRequest());
  }
}
